import React from 'react';
import { Helmet } from "react-helmet";
const AboutUs = () => {
    return (
        <div className="flex justify-center items-center mt-4 mb-1">
            <Helmet>
                <title>CONTACT Tecom.</title>
            </Helmet>
            <div className="max-w-lg bg-white shadow-lg rounded-lg overflow-hidden">
                <div className="px-6 py-4">
                    <div className="font-bold text-xl mb-2">Thông tin liên lạc</div>
                    <div className="mb-4">
                        <h2 className="text-lg font-bold mb-2">Công ty Tecom:</h2>
                        <ul className="list-disc pl-6">
                            <li className="text-gray-700">TELEVISON TECHNOLOGY COMMUNICATION JOINT STOCK COMPANY</li>
                            <li className="text-gray-700">Mã số thuế: 0101550602</li>
                            <li className="text-gray-700">Ngày hoạt động: 2004-10-22</li>
                        </ul>
                    </div>
                    <div className="mb-4">
                        <h2 className="text-lg font-bold mb-2">Địa điểm hoạt động</h2>
                        <ul className="list-disc pl-6">
                            <li>Phường Thanh Lương, Quận Hai Bà Trưng, Hà Nội, Việt Nam</li>
                        </ul>
                    </div>

                    <div className="border-2 bg-white p-2 rounded-lg shadow-xl max-w-xl">
                        <h2 className="text-lg font-semibold mb-1 text-center text-gray-800">LIÊN HỆ Zalo</h2>
                        <p className="text-center text-gray-700 text-xl">0367776906</p>
                    </div>
                    <div className="border-2 bg-white mt-2 p-2 rounded-lg shadow-xl max-w-xl">
                        <h2 className="text-lg font-semibold mb-1 text-center text-gray-800">LIÊN HỆ Email</h2>
                        <p className="text-center text-gray-700 text-xl">contact@hust.media</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
